import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Text from "../../Text/Text"; // This component is to fill the gap between InfoCircle and the hover info

const HoverInfoStyle = styled.div`
  position: absolute;
  background: white;
  color: white;
  right: -5px;
  width: 5px;
  top: 20px;
  cursor: default;
`;

const HoverInfo = ({
  className,
  hoverInfoDescriptions
}) => /*#__PURE__*/React.createElement("div", {
  className: className
}, /*#__PURE__*/React.createElement(Text, {
  color: "#ccc"
}, hoverInfoDescriptions), /*#__PURE__*/React.createElement(HoverInfoStyle, null, "."));

HoverInfo.propTypes = {
  className: PropTypes.string,
  hoverInfoDescriptions: PropTypes.string
};
export default styled(HoverInfo)`
  display: inline-block;
  position: absolute;
  top: -20px;
  right: 20px;
  width: 215px;
  padding: 15px;
  background: #333;
  z-index: 500;
  > p > a {
    color: #fff;
  }
`;